import React from 'react';
import { useOverlayPanelModelStackGuardForModal } from '../store/overlay-panel-modal-stack-store';
import WarningAlertDialog from './WarningAlertDialog';

export default function DiscardUnsavedContentDialog({
  open,
  onOpenChange,
  onDiscard,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
}) {
  useOverlayPanelModelStackGuardForModal(open);

  const onDiscardClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onDiscard();
  };

  const onESC = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <WarningAlertDialog
      open={open}
      onOpenChange={onOpenChange}
      onAction={onDiscardClick}
      actionLabel="Discard"
      onEscapeKeyDown={onESC}
    >
      <p className="font-semibold">You have unsaved changes!</p>
      <p>Discard changes and close the form?</p>
    </WarningAlertDialog>
  );
}
